
import React from 'react';
import { StatCardData } from './types';

export const createInitialStatCards = (
  totalMeters: number, 
  criticalMeters: number,
  totalGateways: number,
  criticalGateways: number,
  isLoading: boolean
): StatCardData[] => {
  return [
    {
      id: 'stat-meter-total',
      title: 'Total Meters',
      value: isLoading ? '--' : totalMeters.toString(),
      change: '2.1%',
      isIncreasing: true,
      icon: null, // Will be set by StatsGrid
      bgClass: 'bg-blue-100 dark:bg-blue-900/20',
      delay: 0.1,
      order: 0,
      visible: true
    },
    {
      id: 'stat-device-critical',
      title: 'Critical Meters',
      value: isLoading ? '--' : criticalMeters.toString(),
      change: '-0.5%',
      isIncreasing: false,
      icon: null, // Will be set by StatsGrid
      bgClass: 'bg-red-100 dark:bg-red-900/20',
      delay: 0.2,
      order: 1,
      visible: true
    },
    {
      id: 'stat-gateway-total',
      title: 'Total Gateways',
      value: isLoading ? '--' : totalGateways.toString(),
      change: null,
      isIncreasing: null,
      icon: null, // Will be set by StatsGrid
      bgClass: 'bg-purple-100 dark:bg-purple-900/20',
      delay: 0.3,
      order: 2,
      visible: true
    },
    {
      id: 'stat-gateway-critical',
      title: 'Critical Gateways',
      value: isLoading ? '--' : criticalGateways.toString(),
      change: '1.2%',
      isIncreasing: true,
      icon: null, // Will be set by StatsGrid
      bgClass: 'bg-orange-100 dark:bg-orange-900/20',
      delay: 0.4,
      order: 3,
      visible: true
    }
  ];
};
